import { render, staticRenderFns } from "./Forma31.vue?vue&type=template&id=1caba511&scoped=true&"
import script from "./Forma31.vue?vue&type=script&lang=js&"
export * from "./Forma31.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1caba511",
  null
  
)

export default component.exports